module.exports = __webpack_public_path__ + "img/logo.e467de9b.png";